import type { Title as TitleNative } from "./Title.native"
import type { Title as TitleReact } from "./Title.react"
import type { Title as TitleWeb } from "./Title.web"
import type { Size, TitleProps } from "./types"

type TitleComponent = typeof TitleWeb | typeof TitleNative | typeof TitleReact

export const createVariant = (Title: TitleComponent, size: Size) => {
  const TitleVariant: React.FC<Omit<TitleProps, "size">> = props => <Title {...props} size={size} />
  TitleVariant.displayName = `Title${size}`
  return TitleVariant
}
